import { render, staticRenderFns } from "./DynamicRouter.vue?vue&type=template&id=b4bf0eb0&scoped=true&"
import script from "./DynamicRouter.vue?vue&type=script&lang=js&"
export * from "./DynamicRouter.vue?vue&type=script&lang=js&"
import style0 from "./DynamicRouter.vue?vue&type=style&index=0&id=b4bf0eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bf0eb0",
  null
  
)

export default component.exports